module.exports = __webpack_public_path__ + "static/media/x.3e244b1a.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/component/sounds/x.mp3
// module id = 113
// module chunks = 0